import React, { useState, useEffect } from "react";
import axios from "axios";
import { APILINK } from "../../EndPoint";
import ErrorHandler from "../../error-handler/ErrorHandler";
import { Container, Row, Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Button } from "antd";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import "../../stylesheets/detailsForm.css";

const axiosApiInstance = axios.create();
const CreateUsers = (props) => {
  const { t } = useTranslation();
  const [disabled, setDisabled] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
  } = useForm();
  const selectedBank = watch("bank");
  const selectedGroup = watch("groups");
  const [groups, setGroups] = useState([]);

  const [data, setData] = useState([]);

  const onSubmit = async (data) => {
    setDisabled(true);
    console.log(data);
    let result;
    if (props.user.is_superuser) {
      result = await axiosApiInstance
        .post(APILINK + `/bank_admin_signup`, data)
        .catch((err) => {
          console.log(err.response);
          setDisabled(false);
          for (const error in err.response.data.error) {
            console.log(err.response.data.error[error][0]);
            setTimeout(() => {
              toast.error(`${err.response.data.error[error][0]}`);
            }, 500);
          }
        });
    } else {
      result = await axiosApiInstance
        .post(APILINK + `/create_bank_user`, data)
        .catch((err) => {
          console.log(err.response);
          setDisabled(false);
          for (const error in err.response.data.error) {
            console.log(err.response.data.error[error][0]);
            setTimeout(() => {
              toast.error(`${err.response.data.error[error][0]}`);
            }, 500);
          }
        });
    }

    console.log(result);
    if (result) {
      setTimeout(() => {
        toast.info(t("success"));
      }, 500);
      setDisabled(false);
    }
  };
  const getBanks = async () => {
    let result = await axiosApiInstance.get(APILINK + `/banks`);
    setData(result.data);
  };
  const getGroups = async () => {
    let result = await axiosApiInstance.get(APILINK + `/get_groups`);
    setGroups(result.data);
  };
  useEffect(() => {
    getBanks();
    getGroups();
  }, []);

  const handleGroup = (e) => {
    console.log(e);
    setValue("groups", e.target.value);
  };

  const handleBank = (e) => {
    console.log(e);
    setValue("bank", e.target.value);
  };
  return (
    <Container
      style={{
        textAlign: localStorage.getItem("lang") == "ar" ? "right" : "left",
      }}
      className="viewSuper align-left usersForm"
    >
      <Row>
        <Col lg={12}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <Row>

              <h4 className="title">{t("CreateUser")}</h4>
              <Col lg={6}>
                <label className="label" >
                  {" "}
                  {t("createForm.name")}
                </label>
                <Form.Control {...register("name", { required: true })} />

                <p className="error">
                  {errors.name?.type === "required" && t("errors.required")}
                </p>
              </Col>

              <Col lg={6}>
                <label className="label">{t("createForm.email")}</label>

                <Form.Control type="text" {...register("email", { required: true })} />
                <p className="error">
                  {errors.email?.type === "required" &&
                    t("errors.required")}
                </p>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <label className="label"> {t("createForm.userName")}</label>
                <Form.Control {...register("username", { required: true })} />

                <p className="error">
                  {errors.username?.type === "required" &&
                   t("errors.required")}
                </p>
              </Col>

              <Col lg={6}>
                <label className="label">{t("createForm.password")}</label>

                <Form.Control
                  type="password"
                  {...register("password", { required: true })}
                />
                <p className="error">
                  {errors.password?.type === "required" &&
                    t("errors.required")}
                </p>
              </Col>
            </Row>
            {props.user.is_superuser ? (
              <Row>
                <Col lg={6}>
                  <label className="label"> {t("createForm.bank")}</label>
                  <Form.Select
                    className="form-control"
                    onChange={handleBank}
                    value={selectedBank}
                    className="w-100"
                    {...register("bank", { required: true })}
                  // onClick={getBanks}
                  >
                    <option value="" selected hidden disabled>
                      {t("createForm.bank")}
                    </option>
                    {data.map((item) => {
                      return (
                        <option value={item.id}>
                          {item.name_en}-{item.name_ar}
                        </option>
                      );
                    })}
                  </Form.Select>
                  <p className="error">
                    {errors.bank?.type === "required" &&
                      t("errors.required")}
                  </p>
                </Col>
              </Row>
            ) : (
              <Row>
                <Col lg={6}>
                  <label className="label"> {t("createForm.group")}</label>
                  <Form.Select

                    onChange={handleGroup}
                    value={selectedGroup}
                    className="w-100"
                    {...register("groups", { required: true })}
                  >
                    <option value="" selected hidden disabled>
                      {t("createForm.group")}
                    </option>
                    {groups.map((item) => {
                      return <option value={item.id}>{item.name}</option>;
                    })}
                  </Form.Select>
                  <p className="error">
                    {errors.groups?.type === "required" &&
                      t("errors.required")}
                  </p>
                </Col>
              </Row>
            )}

            <div className="formSubmit">

              <button
                disabled={disabled}
                className="defaultButton"
                type="submit"
                onClick={handleSubmit(onSubmit)}
              >
                {t("buttons.finish")}
              </button>
            </div>

          </form>
        </Col>
      </Row>

      <ToastContainer position="bottom-right" />
    </Container>
  );
};

const mapStateToProps = (state) => ({
  user: state.auth.user,
});

export default connect(
  mapStateToProps,
  null
)(ErrorHandler(CreateUsers, axiosApiInstance));
